module.exports = __webpack_public_path__ + "img/potencia_a_blue.5d777696.svg";